import { useSelector, useDispatch } from "react-redux";
import { setOfflineTemperature } from "../redux/chartoptions";
import { useState } from "react";
import IndividualComponentPopup from "./individualcomponentpopup";

let T_avg=0;
let T_min=0;
let T_max=0;


function OfflineTemperature(){

    const [showModal,setShowModal] = useState(false);

    const myData = useSelector(state => state.offlineApi)
 
         let sum=0;
         
          T_max = Math.max(...myData.offline_Temperature);
          T_min = Math.min(...myData.offline_Temperature);
 
         myData.offline_Temperature.forEach(num =>{
            // if (isNaN(num)) {
            //     num = 0;
            // }
             sum+=num;
         })
         
         T_avg = sum/Object.keys(myData.offline_Temperature).length;

         const dispatch = useDispatch();
         const checked = useSelector(state => state.chartOption.offline_Temperature)

         const showPopup = () =>{
            setShowModal(true);
        }
    
        const hidePopup = () =>{
            setShowModal(false);
        }
        
         

    return(
        <>
            <div className="parameter" id="offline-temperature" onClick={showPopup}>
                <div className="label2">
                    <input type="checkbox" id="offlinetemperature" checked={checked} onChange={(e) => {dispatch(setOfflineTemperature(e.target.checked))}} />
                    <label htmlFor="offlinetemperature" >Offline &shy;Temperature</label>
                </div>
           
                <div className="parameter_ul">
                    <ul>
                        <li type="none">{T_min.toFixed(2)} <br /> min</li>
                        <li type="none">{T_max.toFixed(2)} <br /> max</li>
                        <li type="none">{T_avg.toFixed(2)} <br /> avg</li>
                        
                    </ul>
                </div>
            </div>
            {showModal && <IndividualComponentPopup hider={hidePopup} bgcolor={"#de3c6259"} />}
        </>
    );
}

export default OfflineTemperature;